import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import { object, string } from "yup";
import { aiService } from "../../service/api.service";
import { setItem, getItem } from "../../util/localStorage";
import swal from "sweetalert";
import { useGlobalValues } from "../../context/globalValues";
export const Login = () => {

  const [loginObj, setLoginObj] = useState({
    email: "",
    password: "",
    role: "Admin"
  });
  const [showPassword, setShowPassword] = useState(false);
  const { setUserDetails } = useGlobalValues()
  const requestFormSchema = object({
    email: string().email().required("Email is required").trim(),
    password: string().required("Password is required").trim(),
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (getItem("safe_tek_admin_token")) {
      navigate("/Home");
    }
  }, []);

  async function handleFormSubmit(value, setSubmitting) {
    setSubmitting(true);
    try {

      const data={
        "email":value.email,
        "password":value.password
      }
     
      let response = await aiService.login(data);
      if ((response?.status == 200) && (response?.data)) {
        let responseData = response?.data.data
        if (!responseData.is_superuser) {
          swal({ icon: 'error', text: 'You are not authorised.' })
          return;
        }
        setItem("safe_tek_admin_token",responseData?.token);
        setUserDetails(responseData)
        localStorage.setItem('super_safe',responseData.is_superuser)
        localStorage.setItem("login", true)
        localStorage.setItem("Id", responseData?.id)
       
        swal("Success","You have successfully logged in.", "success").then((value)=>{
          if(value){
            navigate("/Home")
          }
        })
      }
    } catch (error) {
      console.log("??????????????????",error)
      if(error?.response?.status == 400){
        
        swal({icon:"error", text: error?.response?.data?.message, button: "OK", }).then((value) => {
          console.log('OK button clicked after error alert')
        })
      }else{
        swal({icon:"error", text: error?.response?.data?.message ? error?.response?.data?.message: error?.message, button: "OK", }).then((value) => {
          console.log('OK button clicked after error alert')
        })
      }
    } finally {
      setSubmitting(false);
    }
  }

  function FormikErrorMessage(props) {
    return (
      <label id="uname-error" className="text-danger" for={props.for}>
        {props.message}
      </label>
    );
  }

  return (
    <div className="login-area">
      <div className="login-container">
        {/* Left brand panel — hidden on mobile, shown on lg+ */}
        <div className="login-brand-panel">
          <div className="login-brand-logo">
            <img
              src={require("../../assets/images/avaco-logo.png")}
              alt="logo"
              className="logo-image"
            />
          </div>
          <div>
            <h2 className="login-brand-heading">Avaco Administrator Dashboard</h2>
            <p className="login-brand-description">
              Manage users, configurations, and system settings with centralized control and visibility.
            </p>
          </div>
          <div className="login-brand-notice">
            <i className="fa fa-shield" aria-hidden="true"></i>
            <span>Secure environment — authentication required.</span>
          </div>
        </div>

        {/* Right login form panel */}
        <div className="login-form-panel">
          {/* Mobile logo/header — hidden on lg+ */}
          <div className="login-form-mobile-header">
            <img
              src={require("../../assets/images/avaco-logo.png")}
              alt="logo"
              className="login-form-mobile-logo"
            />
          </div>

          <h1 className="login-form-title">Admin Login</h1>
          <p className="login-form-subtitle">Enter your credentials to access the admin panel.</p>

          <Formik
            initialValues={loginObj}
            validationSchema={requestFormSchema}
            enableReinitialize={true}
            onSubmit={(values, { setSubmitting }) => {
              handleFormSubmit(values, setSubmitting);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form autoComplete="off" onSubmit={handleSubmit} className="login-form">
                <div className="login-form-group">
                  <Form.Label className="login-form-label">Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    id="email"
                    name="email"
                    className="login-form-input"
                    value={values.email}
                    onChange={handleChange}
                  />
                  {errors.email && touched.email ? (
                    <FormikErrorMessage
                      for="email"
                      message={errors.email}
                    />
                  ) : null}
                </div>

                <div className="login-form-group">
                  <Form.Label className="login-form-label">Password</Form.Label>
                  <div className="password-input-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      id="password"
                      name="password"
                      className="login-form-input"
                      value={values.password}
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      className="password-toggle-btn"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                      <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} aria-hidden="true"></i>
                    </button>
                  </div>
                  {errors.password && touched.password ? (
                    <FormikErrorMessage
                      for="password"
                      message={errors.password}
                    />
                  ) : null}
                </div>

                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                  className="login-form-button"
                >
                  {isSubmitting ? (
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  ) : (
                    "Login"
                  )}
                </Button>
              </Form>
            )}
          </Formik>

          <div className="login-form-notice">
            <i className="fa fa-info-circle" aria-hidden="true"></i>
            <p>
              This is a <strong>secure admin environment</strong>. Ensure you are authorized before proceeding.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
